import { render, staticRenderFns } from "./SpiritualApp.vue?vue&type=template&id=5e967b40&"
import script from "./SpiritualApp.vue?vue&type=script&lang=js&"
export * from "./SpiritualApp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports